import React, { memo } from 'react';

import MenuItem from '../../../common/components/MenuItem/MenuItem';
import Select from '../../../common/components/Select/Select';
import { MAP_MODE_HEATMAP, MAP_MODE_LIST, MAP_MODE_REGULAR } from '../component';

const ViewModeSelect = memo(
  ({ isMobile, viewMode, onChange }) => {
    const MAP_MODES_OPTIONS = [
      {
        title: 'Regular Map',
        value: MAP_MODE_REGULAR,
      },
      {
        title: 'Heat Map',
        value: MAP_MODE_HEATMAP,
      },
      {
        title: 'List View',
        value: MAP_MODE_LIST,
      },
    ];

    const handleChange = (event) => {
      onChange(event.target.value);
    };

    return (
      <Select
        className={`dashboard-view-select ${isMobile ? 'mobile' : ''}`}
        menuClassName="dashboard-select-menu"
        value={viewMode}
        onChange={handleChange}
      >
        {MAP_MODES_OPTIONS.map(({ title, value }) => (
          <MenuItem key={value} value={value} title={title}>
            {title}
          </MenuItem>
        ))}
      </Select>
    );
  },
  (prevProps, nextProps) => prevProps.viewMode === nextProps.viewMode,
);

export default ViewModeSelect;
